import { COUNTRY_CODES } from './constants';
import { getCountry } from './utils';

const { US, AE, IN } = COUNTRY_CODES;
const delhi = {
  name: 'Delhi',
  category: 'Popular Destinations',
  branch: 'DOM',
  type: 'DEST',
  url: null,
  id: null,
};
const jaipur = {
  name: 'Jaipur',
  category: 'Popular Destinations',
  branch: 'DOM',
  type: 'DEST',
  url: null,
  id: null,
};
const paris = {
  name: 'Paris',
  category: 'Popular Destinations',
  branch: 'OBT',
  type: 'DEST',
  url: null,
  id: null,
};
const singapore = {
  name: 'Singapore',
  category: 'Popular Destinations',
  branch: 'OBT',
  type: 'DEST',
  url: null,
  id: null,
};
const agra = {
  name: 'Agra',
  category: 'Popular Destinations',
  branch: 'DOM',
  type: 'DEST',
  url: null,
  id: null,
};

const PopularDest = {
  [IN]: [
    {
      name: 'Himachal',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Goa',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Kashmir',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Thailand',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Kerala',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'North East',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Ladakh',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Maldives',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
  ],
  [US]: [
    delhi,
    agra,
    jaipur,
    paris,
    {
      name: 'Pattaya',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Maldives',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
    singapore,
  ],
  [AE]: [
    paris,
    {
      name: 'Phuket',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Sydney',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Los Angeles',
      category: 'Popular Destinations',
      branch: 'OBT',
      type: 'DEST',
      url: null,
      id: null,
    },
    singapore,
    delhi,
    agra,
    jaipur,
    {
      name: 'Mumbai',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
    {
      name: 'Jodhpur',
      category: 'Popular Destinations',
      branch: 'DOM',
      type: 'DEST',
      url: null,
      id: null,
    },
  ],
};

export default function () {
  return PopularDest[getCountry()];
}
